import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";

import SectionTitle from "../home/SectionTitle";
import SliderLine from "../home/SliderLine";

const CARDS = [
  { titleKey: "trading.account.card1.title", textKey: "trading.account.card1.text" },
  { titleKey: "trading.account.card2.title", textKey: "trading.account.card2.text" },
  { titleKey: "trading.account.card3.title", textKey: "trading.account.card3.text" },
  { titleKey: "trading.account.card4.title", textKey: "trading.account.card4.text" },
  { titleKey: "trading.account.card5.title", textKey: "trading.account.card5.text" },
  { titleKey: "trading.account.card6.title", textKey: "trading.account.card6.text" },
];

function AccountCard({ card, t }) {
  return (
    <Fade triggerOnce direction="up" duration={600} className="h-full">
      <div className="relative h-full overflow-hidden rounded-[20px] p-[25px] lg:p-[32px] bg-[#1c385f] border border-[rgba(255,255,255,0.08)] flex flex-col gap-[12px] hover:-translate-y-[4px] transition-transform duration-300">
        <div className="absolute left-0 top-0 bottom-0 w-[4px] bg-[#4da6ff]" />
        <div className="check-icon-blue">
          <Check className="w-[14px] h-[14px] text-[#4da6ff]" strokeWidth={2.5} />
        </div>
        <p className="font-['Inter'] font-bold text-[16px] lg:text-[20px] leading-[1.2] text-white">
          {t(card.titleKey)}
        </p>
        <p className="font-16-14-dark">{t(card.textKey)}</p>
      </div>
    </Fade>
  );
}

function OneAccount() {
  const { t } = useTranslation();
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt">
      <div className="glcontainer">
        <SectionTitle
          title1={t("trading.account.title1")}
          title2={t("trading.account.title2")}
          text={t("trading.account.subtitle")}
          className="mx-auto max-w-[533px]"
        />

        {/* Desktop: сетка 2x3 с разделителем */}
        <div className="hidden lg:flex flex-col gap-[24px] mt-[50px]">
          <div className="grid grid-cols-3 gap-[24px]">
            {CARDS.slice(0, 3).map((card) => (
              <AccountCard key={card.titleKey} card={card} t={t} />
            ))}
          </div>
          <div className="h-px w-full bg-[rgba(28,56,95,0.3)]" />
          <div className="grid grid-cols-3 gap-[24px]">
            {CARDS.slice(3).map((card) => (
              <AccountCard key={card.titleKey} card={card} t={t} />
            ))}
          </div>
        </div>

        {/* Mobile / tablet: слайдер */}
        <div className="lg:hidden mt-[25px]">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
            spaceBetween={16}
            slidesPerView={1}
            grabCursor
            breakpoints={{ 640: { slidesPerView: 2, spaceBetween: 20 } }}
          >
            {CARDS.map((card) => (
              <SwiperSlide key={card.titleKey} className="!h-auto">
                <AccountCard card={card} t={t} />
              </SwiperSlide>
            ))}
          </Swiper>
          <SliderLine
            current={current}
            total={CARDS.length}
            onPrev={() => swiperRef.current?.slidePrev()}
            onNext={() => swiperRef.current?.slideNext()}
          />
        </div>
      </div>
    </section>
  );
}

export default OneAccount;
